import { CEAttachmentBase } from './ce-attachment-base'


export class CEAttachment extends CEAttachmentBase {

}